import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Invitation from "./Invitation";
import AccountingFirmInvitation from "./AccountingFirmInvitation";
import InvitationLogs from "./InvitationLogs";

const tabsKey = {
  "invitations-from-builder": 1,
  "invitations-from-accounting-firm": 2,
  "invitations-to-builder": 3,
  "invitations-to-accounting-firm": 4,
};

const InvitationTab = () => {
  const location = useLocation();
  // const role = localStorage.getItem("role");
  const roleType = localStorage.getItem("roleType");
  const query = new URLSearchParams(location.search);
  const selectedTab = query.get("childTab") || (roleType !== "Builder" ? "invitations-from-builder": "invitations-from-accounting-firm");
  const defaultActiveKey = tabsKey[selectedTab.replace(/\?.*/, "")];

  const [activeTab, setActiveTab] = useState(
    parseInt(defaultActiveKey) === 2 && roleType === "Builder"
      ? "invitations-from-accounting-firm"
      : parseInt(defaultActiveKey) === 1 && roleType !== "Builder"
      ? "invitations-from-builder"
      : parseInt(defaultActiveKey) === 3 && roleType !== "Builder"
      ? "invitations-to-builder"
      : "invitations-to-accounting-firm"
  );
  // const navigate = useNavigate();

  // useEffect(() => {
  //   navigate(`/user-settings?tab=invitations&childTab=${activeTab}`, {
  //     replace: true,
  //   });
  // }, [activeTab, navigate]);

  return (
    <>
      {/* {activeTab === "invitations-from-builder" && <Workinprogrees />} */}
      <div className="table-top-btn">
        <ul
          className="nav nav-tabs"
          onClick={(event) => {
            setActiveTab(
              event?.target?.innerText.replace(/ /g, "-").toLowerCase()
            );
          }}
        >
          {roleType && roleType !== "Admin" && (
            <>
              {roleType !== "Builder" && (
                <li
                  className={
                    activeTab === "invitations-from-builder" ? "active" : ""
                  }
                >
                  <Link key={1}>Invitations From Builder</Link>
                </li>
              )}
            </>
          )}
          {roleType && roleType !== "Admin" && (
            <>
              {roleType === "Builder" && (
                <li
                  className={
                    activeTab === "invitations-from-accounting-firm"
                      ? "active"
                      : ""
                  }
                >
                  <Link key={2}>Invitations From Accounting Firm</Link>
                </li>
              )}
            </>
          )}

          {roleType && roleType !== "Admin" && (
            <>
              {roleType !== "Builder" && (
                <li
                  className={
                    activeTab === "invitations-to-builder" ? "active" : ""
                  }
                >
                  <Link key={1}>Invitations to Builder</Link>
                </li>
              )}
            </>
          )}
          {roleType && roleType !== "Admin" && (
            <>
              {roleType === "Builder" && (
                <li
                  className={
                    activeTab === "invitations-to-accounting-firm"
                      ? "active"
                      : ""
                  }
                >
                  <Link key={2}>Invitations To Accounting Firm</Link>
                </li>
              )}
            </>
          )}
        </ul>
      </div>
      <div className="custom-table tab-table">
        {activeTab === "invitations-from-builder" && roleType !== "Builder" && (
          <Invitation />
        )}
        {activeTab === "invitations-from-accounting-firm" &&
          roleType === "Builder" && <AccountingFirmInvitation />}
        {(activeTab === "invitations-to-builder" ||
          activeTab === "invitations-to-accounting-firm") && <InvitationLogs />}
      </div>
    </>
  );
};

export default InvitationTab;
